import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../../../store/Admin/authentication/authentication.actions";
import StateSelectors from "../../../utils/Admin/constants/selector.constants";
import "./loginpage.css";
import logo from "../../../assets/Admin/logo.svg";
import { encryptText } from "../../../utils/Admin/helpers/encryption";
import useAuth from '../../../utils/Admin/helpers/useAuth'
import { hideLoader, showLoader } from "../../../store/Admin/Loader/loader.slice";

const LoginPage = (props) => {
  const navigate = useNavigate();
  /** to dispatch redux action */
  const dispatch = useDispatch();

  /** get redux user state  */
  const { info, errorMsg, tokenExpired } = useSelector(StateSelectors.USER_SELECTOR);

  /** component states */
  const [userInputs, setUserInputs] = useState({ username: "", password: "" });
  const [fieldFocused, setFieldFocused] = useState({});
  const user = useAuth()

  /** capture input box values  */
  const updateUserInputs = (ev) => {
    setUserInputs({
      ...userInputs,
      [ev.target.name]: ev.target.value,
    });
  };

  /** capture input box values  */
  const onFieldBlur = (ev) => {
    setFieldFocused({ ...fieldFocused, [ev.target.name]: true });
  };

  /** dispatch login action  */
  const onLoginFormSubmit = (ev) => {
    ev.preventDefault();
    dispatch(showLoader('Logging you in...'))
    const payload = {
      username: userInputs.username,
      password: encryptText(userInputs.password),
      grant_type: "password",
    };
    dispatch(loginUser(payload));
    setUserInputs({ username: "", password: "" });
    setFieldFocused({});
  };

  useEffect(() => {
    if (typeof info?.message !== 'undefined') {
      dispatch(hideLoader())
      if (info.message === 'success') {
        navigate("upload");
      }
    } else {
      dispatch(hideLoader())
    }
  }, [info, tokenExpired]);

  useEffect(() => {
    if (user === true) {
      navigate("upload");
    }
  }, [])

  return (
    <section className="w-100 h-100 bg-custom-grey login-section d-flex align-items-center justify-content-center">
      <div className="row no-row-margin justify-content-center align-items-center align-middle w-100 flex-column">
        <img
          width="50"
          height="50"
          src={logo}
          alt="K-fintech"
          className="mb-5"
        />
        <form
          className="col-6 col-lg-4 col-xl-4 py-4 px-5 login-form bg-white mt-2"
          onSubmit={onLoginFormSubmit}
        >
          <h5 className="text-uppercase text-center pt-3 py-2">login</h5>
          <div className="w-100">
            <p
              hidden={errorMsg.length === 0}
              className="mb-0 text-danger fs-16px px-0 py-2 mb-0 text-center text-capitalize"
            >
              {errorMsg}
            </p>
            <label
              className="input-label mb-2 d-block text-capitalize cl-custom-grey"
              htmlFor="username"
            >
              user ID
            </label>
            <input
              pattern="^[0].*$"
              minLength="5"
              maxLength="15"
              required
              onBlur={onFieldBlur}
              data-touched={fieldFocused.username}
              className="input-field w-100"
              type="text"
              name="username"
              id="useremail"
              onChange={updateUserInputs}
              value={userInputs.username}
            />
            <p
              hidden={userInputs.username.length >= 1}
              className="error-text mt-1"
            >
              field is required
            </p>
            <p
              className={
                userInputs.username.length > 0 && userInputs.username.length < 5
                  ? "error-text mt-1"
                  : "d-none"
              }
            >
              Minimum 5 characters required
            </p>
            <p
              className={
                userInputs.username.length >= 5 &&
                !userInputs.username.match("^[0].*$")
                  ? "error-text mt-1"
                  : "d-none"
              }
            >
              invalid user id
            </p>
          </div>
          <div className="w-100 mt-4 mb-2">
            <label
              className="input-label mb-2 d-block text-capitalize cl-custom-grey"
              htmlFor="password"
            >
              password
            </label>
            <input
              required
              minLength="5"
              maxLength="20"
              onBlur={onFieldBlur}
              data-touched={fieldFocused.password}
              className="input-field w-100"
              type="password"
              name="password"
              id="userpassword"
              onChange={updateUserInputs}
              value={userInputs.password}
            />
            <p
              hidden={userInputs.password.length >= 1}
              className="error-text mt-1"
            >
              field is required
            </p>
            <p
              hidden={userInputs.password.length === 0}
              className="error-text mt-1"
            >
              Password must contain at least 5 characters
            </p>
          </div>

          <button
            type="submit"
            className="btn w-100 mt-4 text-capitalize text-white py-3"
          >
            login
          </button>
          <p className="text-center mb-0 mt-4 text-capitalize cl-custom-blue cursor-pointer cancel-link">
            cancel
          </p>
        </form>
      </div>
    </section>
  );
};

export default LoginPage;
